<div class="drug-revenue-filter">
  <div
    *ngIf="
      loading &&
      ((activePanel === panel.key && refreshCurrentPanel) ||
        activePanel !== panel.key)
    "
  >
    <va-custom-skeleton
      [customSkeletonConfig]="customSkeletonConfig"
    >
    </va-custom-skeleton>
  </div>
  <ng-container *ngIf="!loading || (activePanel == panel.key && !refreshCurrentPanel) && data" >
    <div  class="risk-type-section" *ngIf="data">
      <div class="dd-container">
        <span class="label-and-select">
          <span class="label">Risk Type</span>
          <nz-select
            nzPlaceHolder="Select a Risk Type"
            [(ngModel)]="selected_risk_type"
            (ngModelChange)="onDropdownChange($event)"
            class="risk-type">
            <nz-option
              *ngFor="let riskType of data.risk_type_list"
              [nzValue]="riskType.key"
              [nzLabel]="riskType.label"
            ></nz-option>
          </nz-select>
        </span>
        <span class="label-and-select">
          <span class="label">Revenue Year</span>
          <nz-select
            nzPlaceHolder="Select a Revenue Year"
            [(ngModel)]="selected_year"
            (ngModelChange)="onDropdownChange($event)"
            class="risk-type">
            <nz-option
              *ngFor="let year of data.year_list"
              [nzValue]="year.key"
              [nzLabel]="year.label"
            ></nz-option>
          </nz-select>
        </span>
      </div>
      
      <div class="slider-section">
        <app-graph-slider
          [xSeries]="data.drug_revenues"
          [ySeries]="data.no_of_drugs"
          [min]="data.min"
          [max]="data.max"
          label="Amount"
          [magnitude]="data.magnitude"
          [currency]="data.currency"
          [selectedMin]="(facetFilter && facetFilter.selected_min)|| data.min"
          [selectedMax]="(facetFilter && facetFilter.selected_max) || data.max"
          (onSelectionChange)="onRevenueChange($event)"
        ></app-graph-slider>
      </div>
    </div>
  </ng-container>
  
</div>